var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVCms03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2725 39.9355C18.0167 39.9355 18.6201 40.5389 18.6201 41.2832C18.6201 42.0275 18.0167 42.6309 17.2725 42.6309C16.5281 42.6309 15.9248 42.0275 15.9248 41.2832C15.9248 40.5389 16.5281 39.9355 17.2725 39.9355Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 0.673863L13.9033 3.36918H20.6416L21.9893 0.673863M5.14355 37.2404H29.4014",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.251 45.3262H7.83887C6.35654 45.3262 5.14355 44.1133 5.14355 42.6309V3.36914C5.14355 1.88672 6.35645 0.673832 7.83887 0.673832H26.7061C28.1885 0.673832 29.4014 1.88699 29.4014 3.36914V8.08585M17.9463 45.3262H16.5986M29.4014 30.9961V42.6309C29.4014 44.113 28.1882 45.3262 26.7061 45.3262H19.2939",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86035 17.8564H15.251M9.86035 21.2255H15.251M9.86035 24.5946H15.251M9.86035 14.4873H15.251",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.095 15.2834C27.0079 14.5734 28.1552 14.1504 29.4014 14.1504C32.3785 14.1504 34.792 16.5638 34.792 19.541C34.792 22.5181 32.3785 24.9316 29.4014 24.9316C26.4242 24.9316 24.0107 22.5181 24.0107 19.541C24.0107 18.2948 24.4337 17.1475 25.1439 16.2346M27.6391 8.08585H31.1637V10.0086C32.5291 10.2594 33.7941 10.7965 34.8949 11.5551L36.2551 10.1948L38.7475 12.6871L37.3872 14.0472C38.1459 15.1479 38.6829 16.4132 38.9338 17.7786H40.8564V21.3033H38.9338C38.6829 22.6687 38.1459 23.9338 37.3873 25.0345L38.7475 26.3947L36.2552 28.887L34.895 27.5269C33.7943 28.2857 32.529 28.8223 31.1637 29.0733V30.9961H27.6391V29.0733C26.2735 28.8225 25.0085 28.2854 23.9077 27.5267L22.5475 28.887L20.0552 26.3947L21.4154 25.0344C20.6567 23.9338 20.12 22.6686 19.8689 21.3033H17.9463V17.7786H19.8689C20.1198 16.4132 20.6569 15.1481 21.4155 14.0473L20.0553 12.6872L22.5475 10.1948L23.9078 11.5551C25.0084 10.7963 26.2737 10.2595 27.6391 10.0086V8.08585Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8813 17.2528H31.229M31.229 19.948H32.5767",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.613
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCms03);
export default __webpack_public_path__ + "static/media/vCMS03.d5d169f716a167539b5a929d2fdbb1e3.svg";
export { ForwardRef as ReactComponent };